import { render, staticRenderFns } from "./AsyncWorldMap.vue?vue&type=template&id=0be4f15b"
import script from "./AsyncWorldMap.vue?vue&type=script&lang=js"
export * from "./AsyncWorldMap.vue?vue&type=script&lang=js"
import style0 from "./AsyncWorldMap.vue?vue&type=style&index=0&id=0be4f15b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports